export default __webpack_public_path__ + "static/media/khinkali-round.bb589c07.png";